"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputStateStyles = void 0;
const models_1 = require("../shared/models");
const _1 = require("./");
const helpers_1 = require("./helpers");
const tokens_1 = require("./tokens");
const { primary, greyscale } = tokens_1.COLOURS;
const { red, blue } = primary;
const { silver, white, cloud, night, stone, metal } = greyscale;
const inputStateStyles = ({ state, }) => {
    switch (state) {
        case models_1.InputStates.ERROR:
            return {
                border: (0, helpers_1.setWiderBorderColour)(red[75]),
                backgroundColor: white,
            };
        case models_1.InputStates.FOCUS:
            return {
                border: (0, helpers_1.setWiderBorderColour)(night),
                backgroundColor: white,
            };
        case models_1.InputStates.SELECTED:
            return {
                border: (0, helpers_1.setWiderBorderColour)(blue[100]),
                backgroundColor: white,
            };
        case models_1.InputStates.HOVER:
            return {
                backgroundColor: blue[5],
                border: (0, helpers_1.setWiderBorderColour)(metal),
            };
        case models_1.InputStates.DISABLED:
            return {
                backgroundColor: cloud,
                border: (0, helpers_1.setWiderBorderColour)(silver),
            };
        // These bordered states are not used in the Input components
        // They apply to the radio and checkboxes component.
        case models_1.InputStates.BORDERED_DEFAULT:
            return {
                backgroundColor: white,
                border: (0, _1.setBorderColour)(silver),
            };
        case models_1.InputStates.BORDERED_FOCUS:
            return {
                backgroundColor: blue[5],
                border: (0, _1.setBorderColour)(night),
            };
        case models_1.InputStates.BORDERED_SELECT:
            return {
                backgroundColor: blue[5],
                border: (0, _1.setBorderColour)(blue[100]),
            };
        default:
            return {
                backgroundColor: white,
                border: (0, _1.setBorderColour)(stone),
            };
    }
};
exports.inputStateStyles = inputStateStyles;
//# sourceMappingURL=Input.js.map